import React from 'react';
import Highcharts, { SeriesOptionsType } from 'highcharts';
import HighchartsReact from 'highcharts-react-official';

import COLORS from '../../core/constants/colors';
import { LineChartModel } from '../../core/models/chart';
import resetTime from '../../core/helpers/date-utils';

export interface IStackedAreaChart {
  title: string;
  yAxisTitle: string;
  data: LineChartModel[];
}

/* eslint-disable react/no-this-in-sfc */
const StackedAreaChart = React.memo(function StackedAreaChart({
  title,
  yAxisTitle,
  data,
}: IStackedAreaChart): JSX.Element {
  const chartData = data.map(
    (item) =>
      ({
        type: 'area',
        name: item.marketName,
        data: item.chart.map((chart) => [resetTime(chart.date), chart.value]),
      } as SeriesOptionsType)
  );

  const options: Highcharts.Options = {
    chart: {
      type: 'area',
      // height: '80%',
      spacingLeft: 0,
      marginRight: 20,
      backgroundColor: 'transparent',
      animation: false,
    },

    credits: {
      enabled: false,
    },

    colors: [...COLORS.stackedChart],

    title: {
      text: undefined,
    },

    subtitle: {
      text: undefined,
    },

    xAxis: {
      type: 'datetime',
      minPadding: 0,
      startOnTick: false,
      // tickPixelInterval: 80,
      tickmarkPlacement: 'on',
      labels: {
        enabled: true,
      },
    },

    yAxis: {
      gridZIndex: 111,
      title: {
        text: yAxisTitle,
      },
    },

    legend: {
      align: 'left',
      x: 65,
      itemDistance: 10,
      itemMarginBottom: 12,
      symbolPadding: 8,
      useHTML: true,
      labelFormatter() {
        if (this.name.includes('Storage net')) {
          return `${this.name} <sub>(3)</sub>`;
        }
        return this.name;
      },
    },

    tooltip: {
      split: true,
      valueDecimals: 2,
      valueSuffix: ` ${yAxisTitle}`,
      xDateFormat: '%A, %b %e',
    },

    plotOptions: {
      series: {
        dashStyle: 'Dash',
        pointPlacement: 'on',
        connectNulls: true,
        animation: false,
      },
      area: {
        stacking: 'normal',
        fillOpacity: 1,
        lineWidth: 0,
      },
    },

    time: {
      useUTC: true,
    },

    series: [...chartData],
  };

  return (
    <div>
      <h3>{title}</h3>
      <HighchartsReact highcharts={Highcharts} options={options} />
    </div>
  );
});

export default StackedAreaChart;
